import { render, staticRenderFns } from "./LandingWeddingFR.vue?vue&type=template&id=9c635efc&scoped=true"
import script from "./LandingWeddingFR.vue?vue&type=script&lang=js"
export * from "./LandingWeddingFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c635efc",
  null
  
)

export default component.exports